import DevelopmentPlan from './components/DevelopmentPlan';
import useViewer from 'packages/kakapo-ui-application/hooks/useViewer';
import { useDevelopmentPlanQuery } from 'generated/graphql';

export default function DevelopmentPlanRoute() {
	const viewer = useViewer();
	const query = useDevelopmentPlanQuery({
		variables: { userID: viewer!.id },
	});

	return (
		<>
			{query.loading && <DevelopmentPlan.Skeleton />}
			{query.data?.user && (
				<DevelopmentPlan onSave={() => query.refetch()} user={query.data.user} />
			)}
		</>
	);
}
